export enum ReportingOption {
  ResultsSummaryReport = 1,
  TrendlineReport = 2,
  IndividualTestReports = 3,
  ExportResults = 4,
}
